import api from "../../../../lib/API"; // nithinok

export const fetchActivities = async (id) => {
  const response = await api.get(`/verve-leads/${id}/activities`);
  return response.data || response;
};
